export default function Logo({ light = false }) {
  return (
    <a href="/" data-testid="logo-link" className="flex items-center gap-3 group">
      <img
        src="/logo-mc.png"
        alt="Logo MC Fisio"
        className={`h-11 w-auto transition-transform duration-500 group-hover:rotate-3 ${light ? "bg-bone rounded-md p-1" : ""}`}
      />
      <span className={`font-serif text-xl leading-none tracking-tight ${light ? "text-bone" : "text-pine"}`}>
        Dott. Matteo Caravetta
        <span className="block text-[11px] font-sans font-semibold uppercase tracking-[0.22em] text-terracotta mt-0.5">
          Fisioterapista
        </span>
      </span>
    </a>
  );
}
